require('./aggregatorMovementsFilter.scss');

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// @ commons
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;

import moment from 'moment';

import Filters from 'components/commons/filters/filters';
import DateFilter from 'components/commons/filters/filters/dateFilter';
import RadioFilter from 'components/commons/filters/filters/radioFilter';
import AmountFilter from 'components/commons/filters/filters/amountFilter';

import { getProductDetails, getTransactionsTink } from 'actions/aggregator/aggregatorData';
import { removeFilter } from 'actions/filters';
import { parseFilters } from 'utilities/filters/filtersParser';

// @ constants
import {
  AGGREGATOR_MOVEMENTS_FILTER,
  AGGREGATOR_MOVEMENTS_RADIO_FILTER_ALL,
  AGGREGATOR_MOVEMENTS_RADIO_FILTER_INCOME,
  AGGREGATOR_MOVEMENTS_RADIO_FILTER_SPEND,
} from 'constants/index';

const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(24, 'months');

class AggregatorMovementsFilterClass extends React.PureComponent {
  componentWillUnmount() {
    this.props.removeFilter();
  }

  handleOnFilter = () => {
    const {
      immFilters,
      getProductDetails,
      getTransactionsTink,
      isTinkAggregator,
      productType,
      productId,
      bankId,
    } = this.props;

    const parsedFilters = parseFilters(immFilters);

    if (!isTinkAggregator) {
      productType &&
        productId &&
        getProductDetails(bankId, productType, productId, null, parsedFilters);
    } else {
      productType &&
        productId &&
        getTransactionsTink(
          productType,
          productId,
          parsedFilters.dateFrom,
          parsedFilters.dateTo,
          parsedFilters
        );
    }
  };

  getOptions = () => [
    {
      label: formatText('aggregatorMovementsFilter-allMovements'),
      value: AGGREGATOR_MOVEMENTS_RADIO_FILTER_ALL,
    },
    {
      label: formatText('aggregatorMovementsFilter-incomeMovements'),
      value: AGGREGATOR_MOVEMENTS_RADIO_FILTER_INCOME,
    },
    {
      label: formatText('aggregatorMovementsFilter-spendMovements'),
      value: AGGREGATOR_MOVEMENTS_RADIO_FILTER_SPEND,
    },
  ];

  render() {
    const { hasStatus } = this.props;

    return (
      <Filters
        extraClass="aggregator-movements-filters"
        filtersId={AGGREGATOR_MOVEMENTS_FILTER}
        onFilter={this.handleOnFilter}
      >
        <h4 className="aggregator-movements-filters__title">
          <FormattedText value="aggregatorMovementsFilter-movementsTitle" />
        </h4>
        <div>
          <h3 className="aggregator-movements-filters__subtitle">
            <FormattedText value="aggregatorMovementsFilter-movementsDate" />
          </h3>
          <div>
            <DateFilter filterId={'date'} minDate={DATE_FILTER_MIN_DATE_LIMIT} />
          </div>
        </div>
        <div>
          <div>
            <AmountFilter filterId={'amount'} />
          </div>
        </div>
        {hasStatus && (
          <div>
            <h3 className="aggregator-movements-filters__subtitle">
              <FormattedText value="aggregatorMovementsFilter-movementsType" />
            </h3>
            <div>
              <RadioFilter
                filterId={'movementType'}
                initialSelected={AGGREGATOR_MOVEMENTS_RADIO_FILTER_ALL}
                noFilterId={AGGREGATOR_MOVEMENTS_RADIO_FILTER_ALL}
                options={this.getOptions()}
              />
            </div>
          </div>
        )}
      </Filters>
    );
  }
}

AggregatorMovementsFilterClass.defaultProps = {
  immFilters: {},
  hasStatus: true,
  getProductDetails: () => null,
  removeFilter: () => null,
  productType: '',
  productId: '',
  getTransactionsTink: () => null,
  isTinkAggregator: false,
};

AggregatorMovementsFilterClass.propTypes = {
  immFilters: PropTypes.object,
  hasStatus: PropTypes.bool,
  getProductDetails: PropTypes.func,
  removeFilter: PropTypes.func,
  productType: PropTypes.string,
  productId: PropTypes.string,
  bankId: PropTypes.string,
  getTransactionsTink: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorMovementsFilter = connect(
  state => ({
    immFilters: state.filters.get(AGGREGATOR_MOVEMENTS_FILTER),
  }),
  {
    getProductDetails,
    getTransactionsTink,
    removeFilter,
  }
)(AggregatorMovementsFilterClass);

export { AggregatorMovementsFilter };
